import React from "react";

export default function SearchCapteur({ searchTerm, handleSearch, handleAjouterCompteur, selectedCapteur }) {
  return (
    <div>
      <p className="text-sm font-medium text-gray-600 mb-3">Associer un compteur</p>
      <input
        className="w-full border border-gray-300 rounded-lg px-4 py-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        type="text"
        placeholder="Entrez le nom du compteur..."
        value={searchTerm}
        onChange={handleSearch}
      />
      {selectedCapteur && (
        <button
          onClick={handleAjouterCompteur}
          className="w-full sm:w-auto mt-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium"
        >
          Ajouter « {selectedCapteur} »
        </button>
      )}
    </div>
  );
}